import {flyToBbox} from '../methods/fly';
import {clearCards} from '../index-info/list';
import {decodeTopojsonFeatures} from '../resources/utils';


export const getPerimeter = slug => {
  return window.fireData.perimeters.features.find(d => d.properties.slug === slug.split(' ').join('-'));
}

let shapePaint = {
  'fill-opacity': [
    "interpolate", ["linear"], ["zoom"],
    6, 0,
    6.5, .75,
  ],
  'fill-pattern': 'texture-orange'
};

let linePaint = {
  'line-color': '#FF7F00',
  'line-width': 1,
  'line-opacity': [
    "interpolate", ["linear"], ["zoom"],
    6, 0,
    6.5, .5,
  ],
  'line-dasharray': [3, 1]
}

export const addPerimetersDetailLayer = () => {
  shapePaint['fill-opacity'] = .9;
  linePaint['line-opacity'] = .8;
  addPerimetersLayer(shapePaint, linePaint);
}

export const addPerimetersIndexLayer = () => {
  addPerimetersLayer(shapePaint, linePaint);
  window.fireMap.on('mouseenter', 'fire-shapes', function(e) {
    window.fireMap.getCanvas().style.cursor = 'pointer';

  });

  window.fireMap.on('mouseleave', 'fire-shapes', function(e) {
    window.fireMap.getCanvas().style.cursor = '';
  });

  window.fireMap.on('click', 'fire-shapes', function(e) {
    let feature = window.fireMap.queryRenderedFeatures(e.point)[0];

    // Clear any existing active cards
    clearCards();

    // Active this fire's card
    const card_id = `card-${feature.properties.slug}`;
    const card = document.getElementById(card_id)
    card.classList.add('active');

    // Fly away
    const bbox = JSON.parse(feature.properties.bbox);
    flyToBbox(bbox);

    // Scroll to card
    card.scrollIntoView({
      block: "start",
      behavior: "smooth"
    });
  });
}

const addPerimetersLayer = (shapePaint, linePaint) => {
    window.fireMap.addLayer({
      id: `fire-shapes`,
      type: 'fill',
      source: {
        type: 'geojson',
        data: window.fireData.perimeters,
      },
      layout: {},
      paint: shapePaint
    }, 'water-point-label');

    window.fireMap.addLayer({
      id: `verified-shapes-outline`,
      type: 'line',
      source: {
        type: 'geojson',
        data: window.fireData.perimeters,
      },
      layout: {},
      paint: linePaint
    }, 'water-point-label');
};
